import axiosHttp from "services/axiosHttp";

const { createSlice, createAsyncThunk } = require("@reduxjs/toolkit");

//action
export const fetchGISDealerCounts = createAsyncThunk("fetchGISDealerCounts", async () => {
	const token = localStorage.getItem("auth_token");
	const config = {
		headers: {
			Authorization: `Bearer ${token}`,
			"Access-Control-Allow-Origin": "*",
			"Content-Type": "application/json",
			Accept: "application/json",
		},
	};

	const response = await axiosHttp.get(`/gis/dealer/location/count`, config);

	return response.data.data;
});

const gisDealerCountsSlice = createSlice({
	name: "gisDealerCountsSlice",
	initialState: {
		isLoading: false,
		data: null,
		error: null,
	},

	extraReducers: (builder) => {
		builder.addCase(fetchGISDealerCounts.pending, (state, action) => {
			state.isLoading = true;
		});

		builder.addCase(fetchGISDealerCounts.fulfilled, (state, action) => {
			state.isLoading = false;
			state.data = action.payload;
		});
		builder.addCase(fetchGISDealerCounts.rejected, (state, action) => {
			state.isLoading = false;
			state.error = action.payload;
		});
	},
});

export default gisDealerCountsSlice.reducer;
